import React, { useRef } from 'react'

const FileInput = ({children}) => {
    const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // You can do something with the selected file here, such as uploading it to a server.
      console.log('Selected file:', selectedFile.name);
    }
  };
  return (
    <div>
    <input
      type="file"
      ref={fileInputRef}
      style={{ display: 'none' }}
      onChange={handleFileChange}
    />
    <button onClick={handleButtonClick}>{children}</button>
  </div>
  )
}

export default FileInput